import { render, staticRenderFns } from "./ColumnSector.vue?vue&type=template&id=be083a1c"
import script from "./ColumnSector.vue?vue&type=script&lang=js"
export * from "./ColumnSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be083a1c')) {
      api.createRecord('be083a1c', component.options)
    } else {
      api.reload('be083a1c', component.options)
    }
    module.hot.accept("./ColumnSector.vue?vue&type=template&id=be083a1c", function () {
      api.rerender('be083a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnSector.vue"
export default component.exports